import { render, staticRenderFns } from "./_generalJournal.vue?vue&type=template&id=01647d2c&scoped=true&"
import script from "./_generalJournal.vue?vue&type=script&lang=js&"
export * from "./_generalJournal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01647d2c",
  null
  
)

export default component.exports